import React from 'react';
import Modal from 'cccisd-modal';
import IconPlus from 'cccisd-icons/plus-circle2';
import style from './style.css';

const addSchool = props => {
    return (
        <Modal
            title="Add School"
            trigger={
                <button type="button" className="btn btn-primary">
                    <IconPlus /> Add School
                </button>
            }
            ref={props.myModalRef}
        >
            <>
                <div className={style.otherFilterOptions}>
                    <div className="mb-3">
                        <label className="form-label">
                            State
                            <select
                                value={props.stateId}
                                onChange={props.onStateSelectChange}
                                className="form-select"
                                style={{ width: 'auto' }}
                            >
                                <option value="">-- Select a State --</option>
                                {props.states.map(option => (
                                    <option key={option.groupId} value={option.groupId}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">
                            District
                            <select
                                value={props.districtId}
                                onChange={props.onDistrictSelectChange}
                                className="form-select"
                                style={{ width: 'auto' }}
                            >
                                <option value="">-- Select a District --</option>
                                {props.districtList.map(option => (
                                    <option key={option.group.groupId} value={option.group.groupId}>
                                        {option.group.label}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">
                            School
                            <select
                                value={props.schoolId}
                                onChange={e => props.setSchoolId(e)}
                                className="form-select"
                                style={{ width: 'auto' }}
                            >
                                <option value="">-- Select a School --</option>
                                {props.schoolList.map(option => (
                                    <option key={option.group.groupId} value={option.group.groupId}>
                                        {option.group.label}
                                    </option>
                                ))}
                            </select>
                        </label>
                    </div>
                </div>
                <div className={style.buttons}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={props.onAddSchoolSubmit}
                        disabled={!(props.stateId && props.districtId && props.schoolId)}
                    >
                        Submit
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default addSchool;
